import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import BackgroundRandomImgComponent from '~/components/BackgroundRandomImg';
import Config from '~/config';

@withI18next(['page-terms-ai'])
class TermsAIPage extends React.Component {
  render() {
    // const t = i18n.getFixedT('en');
    const { t } = this.props;

    return (
      <div className="photo-ac-terms">
        <BackgroundRandomImgComponent className="content-image" />
        <h1 className="title-head text-center bg-gray-head text-white">
          {t('terms_of_ai_service')}
        </h1>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 pv30">
              <div className="term-photo-ac">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t('photo_ac_sub_header_ai_term', {
                      domain: Config.getSiteURL(),
                    }),
                  }}
                />
                <div className="term-photo-ac">
                  <div className="pv border-bottom">
                    <h4 className="bold">{t('photo_ac_title_ai_term_5')}</h4>
                    {t('photo_ac_sub_title_ai_term_5')}
                    <ol className="list-custom">
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_5_1_ai_term'),
                          }}
                        />
                        <ul className="list-unstyled">
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_1_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_3_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_4_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_5_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_6_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_7_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_8_ai_term'),
                              }}
                            />
                          </li>
                          <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_9_ai_term'),
                              }}
                            />
                          </li>
                          {/* <li className="pt">
                            <span
                              dangerouslySetInnerHTML={{
                                __html: t('photo_ac_des_5_1_10_ai_term'),
                              }}
                            />
                          </li> */}
                        </ul>
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_5_2_ai_term'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_5_3_ai_term'),
                          }}
                        />
                      </li>
                    </ol>
                  </div>
                  <div className="pv border-bottom">
                    <h4 className="bold">{t('photo_ac_title_7_ai_term')}</h4>
                    {t('design_ac_sub_title_7')}
                    <ol className="list-custom">
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_7_1'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_7_2'),
                          }}
                        />
                      </li>
                    </ol>
                  </div>
                  <div className="pv border-bottom">
                    <h4 className="bold">{t('design_ac_title_8')}</h4>
                    {t('design_ac_sub_title_8')}
                    <ol className="list-custom">
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_8_1_ai_term'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_8_2_ai_term'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_8_3_ai_term'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('photo_ac_des_8_6_ai_term'),
                          }}
                        />
                      </li>
                    </ol>
                  </div>
                  <div className="pv border-bottom">
                    <h4 className="bold">{t('design_ac_title_9')}</h4>
                    {/* {t('design_ac_sub_title_9')} */}
                    <ol className="list-custom">
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_9_1'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_9_2'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_9_3'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(`${Config.serviceType}_des_9_4`),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(`${Config.serviceType}_des_9_5`),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_9_6'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t('design_ac_des_9_7'),
                          }}
                        />
                      </li>
                      <li className="pb">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(`${Config.serviceType}_des_9_8`),
                          }}
                        />
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style jsx global>
          {`
            .photo-ac-terms .border-bottom .list-custom li:last-of-type {
              padding-bottom: 0;
            }

            .photo-ac-terms .pv.border-bottom:last-of-type {
              border-bottom: 0;
            }

            .term-photo-ac:last-child {
              border-bottom: none !important;
            }

            .content-image {
              margin-bottom: 0;
              margin-top: -1px;
              height: 400px;
            }

            @media screen and (max-width: 767px) {
              .content-image {
                height: 150px !important;
              }
            }

            .photo-ac-terms .row li:hover {
              background-color: transparent;
            }
          `}
        </style>
      </div>
    );
  }
}

export default TermsAIPage;
